import { createEventDefs } from "../event-def";

export const ErrorEvents = createEventDefs<{
  uncaught_error: {
    boundary: "default" | "suspense";
    error_message: string;
    error_name: string;
    error_stack: string | undefined;
    error_component_stack: string | undefined;
  };
}>({
  namespacePrefix: "studio_errors_",
});
